import { Tab, Tabs } from "react-bootstrap";
import "./DetailLearnDiscussComponent.scss";
import { useEffect, useState } from "react";
import DetailPageDiscussComponent from "../DetailPageDiscuss/DetailPageDiscussComponent";
import DetailPageLearnComponent from "../DetailPageLearn/DetailPageLearnComponent";
import useLogin from "../../../../custom-hooks/useLogin";
import { SessionKeys } from "../../../../utils/AppUtils";

const DetailLearnDiscussComponent = (props) => {

    const {
        id, code, type, source, learnData, isLoading,
        showLearn, showDiscuss,onLearnClick, setIsLoading,isMobile
    } = props

    const { isLoggedIn } = useLogin()

    const [key, setKey] = useState('learn')

    useEffect(() => {
        if (showLearn) {
            setKey('learn')
        } else if (showDiscuss) {
            setKey('discuss')
        }
    }, [showLearn, showDiscuss])

    return (
        <>
            <div className="learn-discuss">
                <Tabs
                    underline
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    {
                        showLearn ?
                        <Tab eventKey={'learn'} title="Learn">
                            <DetailPageLearnComponent 
                                learnData = {learnData}
                                setIsLoading={setIsLoading}
                                onLearnClick={onLearnClick}
                                source={source}
                            />
                        </Tab>
                        : ""
                    }
                    {
                        (showDiscuss && isLoggedIn)&& localStorage.getItem(SessionKeys.SHOW_DISCUSS_TAB)!=="false" && false ?
                        <Tab eventKey={'discuss'} title="Discuss">
                            <DetailPageDiscussComponent 
                                id={id}
                                code={code}
                                type={type}
                                source={source}
                                isMobile={isMobile}
                            />
                        </Tab>
                        : ""
                    }
                </Tabs>
            </div>
        </>
    )
}

export default DetailLearnDiscussComponent